import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import LoginPrompt from '../../components/LoginPrompt';
import { Layout } from '../../components/Layout';
import PrizeAsset from '../../components/PrizeAsset/component';
import Terms from '../../components/Terms';
import OpenState from '../../components/SweepDetailState/OpenState';
import ResultedState from '../../components/SweepDetailState/ResultedState';
import InRunningState from '../../components/SweepDetailState/InRunningState';
import BackToHubButton from '../../components/BackToHub';

export const SweepDetailPage = ({
    sweep,
    loggedIn,
    openLogin,
    TermsLink,
    Itv7TermsLink,
    userName,
    ButtonLink,
    hasEventStarted,
    canEnterSweepstake,
    displayCountdownTimer,
    bettingEnabled,
    promotionsConfig
}) => {
    const { name: title, prize, sweepId, sportType, assets } = sweep;
    const prizeImageUrl = get(assets, 'prizeUrl', null);
    const backgroundImageUrl = get(assets, 'backgroundUrl', null);
    const heroBannerImageUrl = get(assets, 'heroBannerUrl', null);
    const { name: eventName, startDate, winningSelections } = sweep.event;
    const hasWinners = !!winningSelections.length;

    let content;

    if (hasWinners) {
        content = (
            <ResultedState
                title={title}
                eventName={eventName}
                prize={prize}
                winningSelectionsData={winningSelections}
                TermsLink={TermsLink}
                Itv7TermsLink={Itv7TermsLink}
                ButtonLink={ButtonLink}
                bettingEnabled={bettingEnabled}
                promotionsConfig={promotionsConfig}
            />
        );
    } else if (hasEventStarted) {
        content = (
            <InRunningState
                title={title}
                eventName={eventName}
                bettingEnabled={bettingEnabled}
                promotionsConfig={promotionsConfig}
            />
        );
    } else {
        content = (
            <OpenState
                title={title}
                eventName={eventName}
                prize={prize}
                prizeImageUrl={prizeImageUrl}
                backgroundImageUrl={backgroundImageUrl}
                TermsLink={TermsLink}
                loggedIn={loggedIn}
                sweepId={sweepId}
                openLogin={openLogin}
                startDate={startDate}
                canEnterSweepstake={canEnterSweepstake}
                displayCountdownTimer={displayCountdownTimer}
            />
        );
    }

    return (
        <Layout
            loggedIn={loggedIn}
            userName={userName}
            sportType={sportType}
            heroBannerUrl={heroBannerImageUrl}
        >
            <BackToHubButton />
            {!loggedIn && hasEventStarted ? (
                <>
                    {prizeImageUrl && (
                        <PrizeAsset
                            prize={prize}
                            prizeImageUrl={prizeImageUrl}
                        />
                    )}
                    <LoginPrompt openLogin={openLogin} hasEventStarted />
                    <Terms startDate={startDate} TermsLink={TermsLink} />
                </>
            ) : (
                content
            )}
        </Layout>
    );
};

SweepDetailPage.defaultProps = {
    userName: null,
    promotionsConfig: null
};

SweepDetailPage.propTypes = {
    sweep: PropTypes.shape({
        prize: PropTypes.string,
        name: PropTypes.string,
        sweepId: PropTypes.string,
        status: PropTypes.string,
        sportType: PropTypes.oneOf(['football', 'racing']),
        assets: PropTypes.shape({
            heroBannerUrl: PropTypes.string,
            prizeUrl: PropTypes.string,
            backgroundUrl: PropTypes.string
        }),
        event: PropTypes.shape({
            name: PropTypes.string,
            startDate: PropTypes.string,
            winningSelections: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                    metaData: PropTypes.shape({
                        clothNumber: PropTypes.string,
                        horseName: PropTypes.string,
                        jockeyName: PropTypes.string,
                        trainerName: PropTypes.string,
                        silk: PropTypes.string
                    })
                })
            )
        })
    }).isRequired,
    loggedIn: PropTypes.bool.isRequired,
    openLogin: PropTypes.func.isRequired,
    TermsLink: PropTypes.func.isRequired,
    Itv7TermsLink: PropTypes.func.isRequired,
    userName: PropTypes.string,
    ButtonLink: PropTypes.func.isRequired,
    hasEventStarted: PropTypes.bool.isRequired,
    canEnterSweepstake: PropTypes.bool.isRequired,
    displayCountdownTimer: PropTypes.bool.isRequired,
    bettingEnabled: PropTypes.bool.isRequired,
    promotionsConfig: PropTypes.shape({
        enabled: PropTypes.bool,
        href: PropTypes.string,
        img: PropTypes.shape({
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    })
};

export default SweepDetailPage;
